/**
 * 业务仓sku库存管理
 */
import { Service } from '@/tools'
export class WhSkuStockService<T extends TStock.WhSkuStock> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.WhSkuStock}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：业务仓sku库存管理
   * /api/stock/whSkuStock/v1/page
   */
  page = (data: T['ApiPage']['req']): Promise<T['ApiPage']['res']> => this.post2('v1/ApiPage', data)
 /**
   * 功能：通过批量skuCode获取业务仓库存
   * /api/stock/whSkuStock/v1/getBizWhSkuStockBySkuCode
   */
 getBizWhSkuStockBySkuCode = (data: T['ApiGetBizWhSkuStockBySkuCode']['req']): Promise<T['ApiGetBizWhSkuStockBySkuCode']['res']> => this.post2('v1/ApiGetBizWhSkuStockBySkuCode', data)
            
  /**
   * 功能：通过业务仓id和skuCode获取业务仓库存
   */
  getBizWhSkuStockByBizWhIdAndSkuCode = (data: T['ApiGetBizWhSkuStockByBizWhIdAndSkuCode']['req']): Promise<T['ApiGetBizWhSkuStockByBizWhIdAndSkuCode']['res']> => this.post2('v1/ApiGetBizWhSkuStockByBizWhIdAndSkuCode', data)
}
